import { useNavigate } from 'react-router-dom';

export default function Sales() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Ventes</h1>
        <p className="mt-2 text-gray-600">Gérez toutes vos activités de vente</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <button
          onClick={() => navigate('/pos')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">🛒</div>
          <h3 className="text-lg font-semibold text-gray-900">Caisse (POS)</h3>
          <p className="text-sm text-gray-600 mt-1">Point de vente</p>
        </button>

        <button
          onClick={() => navigate('/orders')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">📋</div>
          <h3 className="text-lg font-semibold text-gray-900">Commandes</h3>
          <p className="text-sm text-gray-600 mt-1">Gérer les commandes</p>
        </button>

        <button
          onClick={() => navigate('/sales-history')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">📜</div>
          <h3 className="text-lg font-semibold text-gray-900">Historique</h3>
          <p className="text-sm text-gray-600 mt-1">Historique des ventes</p>
        </button>

        <button
          onClick={() => navigate('/stats')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">📊</div>
          <h3 className="text-lg font-semibold text-gray-900">Statistiques</h3>
          <p className="text-sm text-gray-600 mt-1">Analyser les performances</p>
        </button>

        <button
          onClick={() => navigate('/invoices')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">📄</div>
          <h3 className="text-lg font-semibold text-gray-900">Factures Enfact</h3>
          <p className="text-sm text-gray-600 mt-1">Gestion e-invoicing PEPPOL</p>
        </button>
      </div>
    </div>
  );
}
